import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { TKeyInitiativesFinancialField } from '../model/financialData'

export const getPrevYearActualsField = (
  actualsValueType: ActualsValueTypes,
  currency: string = 'USD'
) => {
  const currencyPostfix = currency === 'USD' ? '' : 'LC'

  return `ActualsPY${currencyPostfix}${actualsValueType}` as Extract<
    TKeyInitiativesFinancialField,
    `ActualsPY${string}`
  >
}

export const getPrevYearPlanField = (
  actualsValueType: ActualsValueTypes,
  currency: string = 'USD'
) => {
  const currencyPostfix = currency === 'USD' ? '' : 'LC'

  return `PlansPY${currencyPostfix}${actualsValueType}` as Extract<
    TKeyInitiativesFinancialField,
    `PlansPY${string}`
  >
}

export const getPlanField = (actualsValueType: ActualsValueTypes, currency: string = 'USD') => {
  const currencyPostfix = currency === 'USD' ? '' : 'LC'

  return `PlansCY${currencyPostfix}${actualsValueType}` as Extract<
    TKeyInitiativesFinancialField,
    `PlansCY${string}`
  >
}

export const getPrevYearActualsQuarterField = (
  actualsValueType: ActualsValueTypes,
  currency: string,
  quarter: string
) => {
  const currencyPostfix = currency === 'USD' ? '' : 'LC'
  return `ActualsPY${quarter}${currencyPostfix}${actualsValueType}` as Extract<
    TKeyInitiativesFinancialField,
    `ActualsPY${string}`
  >
}

export const getPlanQuarterField = (
  actualsValueType: ActualsValueTypes,
  currency: string,
  quarter: string
) => {
  const currencyPostfix = currency === 'USD' ? '' : 'LC'
  return `PlansCY${quarter}${currencyPostfix}${actualsValueType}` as Extract<
    TKeyInitiativesFinancialField,
    `PlansCY${string}`
  >
}
